import { ColDef } from 'ag-grid-community';

export const pseDay7ColDefs: ColDef[] = [
  {
    wrapText: true,
    autoHeight: true,
    field: 'checkbox',
    headerName: '',
    width: 30,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressMovable: true,
    lockPosition: true,
  },
  {
    field: 'plateNo',
    headerName: 'Plate N',
    width: 80,
    editable: (params) => params.data?.plateNo === null,
    type: 'numberColumn',
    valueParser: (params) => Number.parseFloat(params.newValue),
  },
  { field: 'mating', headerName: 'Mating', width: 130, editable: false },
  { field: 'semenType', headerName: 'Semen Type', width: 80, editable: false },
  {
    field: 'freshStrawNo',
    headerName: 'Fresh Straw No',
    width: 80,
    editable: true,
    type: 'numberColumn',
    valueParser: (params) => Number.parseInt(params.newValue),
    cellClassRules: {
      'bg-tog-pink': (params) => params.data?.status === 'Discarded',
    },
  },
  {
    field: 'embryoTag',
    headerName: 'Emb Tag',
    width: 80,
    editable: true,
    type: 'numberColumn',
    valueParser: (params) => Number.parseInt(params.newValue),
  },
  { field: 'recipient', headerName: 'Recip', width: 80, editable: false },
  {
    field: 'estrusSync',
    headerName: 'ES',
    width: 50,
    editable: false,
    type: 'numberColumn',
    valueParser: (params) => Number.parseFloat(params.newValue),
  },
  {
    field: 'stage',
    headerName: 'Stg',
    width: 50,
    editable: true,
    type: 'numberColumn',
    valueParser: (params) => Number.parseInt(params.newValue),
  },
  {
    field: 'grade',
    headerName: 'Grd',
    width: 50,
    editable: true,
    type: 'numberColumn',
    valueParser: (params) => Number.parseInt(params.newValue),
  },
  { field: 'cl', headerName: 'C', width: 50, editable: false },
  {
    field: 'transferTech',
    headerName: 'Transfer Tech',
    width: 100,
    editable: false,
  },
  {
    field: 'transferComment',
    headerName: 'Transfer Comment',
    width: 120,
    editable: true,
  },
  {
    field: 'deactivate',
    headerName: 'Deactivate',
    width: 80,
    editable: true,
    type: 'numberColumn',
    valueParser: (params) => Number.parseInt(params.newValue),
  },
  {
    field: 'embryoPartners',
    headerName: 'Embryo Partner',
    width: 100,
    editable: false,
  },
  {
    field: 'donorPartners',
    headerName: 'Donor Partner',
    width: 100,
    editable: false,
  },
  {
    field: 'loadPartners',
    headerName: 'Load Partner',
    width: 100,
    editable: false,
  },
  {
    field: 'dsImplantType',
    headerName: 'DS Implant Type',
    width: 100,
    editable: false,
  },
  {
    field: 'embryoImplantType',
    headerName: 'Emb Implant Type',
    width: 100,
    editable: true,
  },
  {
    field: 'recipFrame',
    headerName: 'Recip Frame',
    width: 80,
    editable: false,
    type: 'numberColumn',
    valueParser: (params) => Number.parseInt(params.newValue),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 80,
    editable: false,
    cellClassRules: {
      'bg-tog-pink': (params) => params.value === 'Discarded',
    },
  },
  { field: 'accountId', headerName: 'Account ID', width: 80, editable: false },
  {
    field: 'shipmentGroup',
    headerName: 'Shipment Group',
    width: 100,
    editable: false,
  },
];

export const pseDay7FrozenEmbryosColDefs: ColDef[] = [
  { field: 'plateNumber', headerName: 'Plate #', width: 50, editable: true },
  { field: 'mating', headerName: 'Mating', width: 200, editable: true },
  { field: 'cane', headerName: 'Cane', width: 80, editable: true },
  { field: 'straw', headerName: 'Straw', width: 50, editable: true },
  { field: 'stage', headerName: 'Stage', width: 50, editable: true },
  { field: 'grade', headerName: 'Grade', width: 50, editable: true },
  { field: 'freezeTime', headerName: 'Freeze Day', width: 50, editable: true },
  {
    field: 'freezeSite',
    headerName: 'Freeze Site',
    width: 100,
    editable: true,
  },
];

export const gradingColumnDefs: ColDef[] = [
  { field: 'row', headerName: '', width: 30, editable: false },
  { field: 'g9', headerName: '9', width: 50, editable: true },
  { field: 'g8', headerName: '8', width: 50, editable: true },
  { field: 'g7', headerName: '7', width: 50, editable: true },
  { field: 'g6', headerName: '6', width: 50, editable: true },
  { field: 'g5', headerName: '5', width: 50, editable: true },
  { field: 'g4', headerName: '4', width: 50, editable: true },
  {
    field: 'total',
    headerName: 'Total',
    width: 60,
    editable: false,
    valueGetter: (params) => {
      const data = params.data;
      return (
        (Number(data.g4) || 0) +
        (Number(data.g5) || 0) +
        (Number(data.g6) || 0) +
        (Number(data.g7) || 0) +
        (Number(data.g8) || 0) +
        (Number(data.g9) || 0)
      );
    },
  },
];
